import React from 'react';
import Modal from 'react-modal';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import {NotificationManager} from "react-notifications";

import * as RaceActions from "../../../../actions/race"
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from '../../../reusable/UserFieldElement';

class PriceAdditionsDialog extends React.Component {

    static propTypes = {
        onClose: PropTypes.func.isRequired,
        onSuccess: PropTypes.func,
        raceId: PropTypes.number.isRequired,
        priceType: PropTypes.string.isRequired,
        sections: PropTypes.array.isRequired,
    };

    static defaultProps = {
        onSuccess: null,
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.getStateFromProps(props));
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this.getStateFromProps(nextProps));
    }

    getStateFromProps(props) {
        const state = {};
        props.sections.forEach(section => {
            state['Section' + section.Sektionsnr] = section.Beloeb === null ? '' : String(section.Beloeb).replace('.', ',');
        });
        return state;
    }

    fields = [];
    render() {
        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => {this.props.onClose()}}
                style={{
                    overlay: {
                        zIndex: 10,
                    },
                    content : {
                        width: '500px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        top: '100px',
                        bottom: '100px',
                    }
                }}
            >
                <div className="dialog">
                    <div className="dialog-title">Præmietillæg</div>

                    <div className="dialog-body">
                        <div className="dialog-inner-body">
                            <table className="fields data-table">
                                <thead>
                                    <tr>
                                        <th>Sektion</th>
                                        <th>Tillæg</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.sections.sort((s1, s2) => s1.Sektionsnr < s2.Sektionsnr ? -1 : (s1.Sektionsnr > s2.Sektionsnr ? 1 : 0)).map((section, ix) => <tr key={section.Sektionsnr}>
                                        <td>Sektion {section.Sektionsnr}</td>
                                        <td>
                                            <UserFieldElement dataType={UserFieldDataType.float} placeholder="" className="field100" containerClassName="display-inline-block"
                                                              name={'Section' + section.Sektionsnr} id={'Section' + section.Sektionsnr} value={this.state['Section' + section.Sektionsnr]}
                                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                              onChange={this.onStandardFieldChange}
                                                              ref={instance => { this.fields[ix] = instance; }}
                                            />
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="actions-row">
                        <button className="btn-primary" onClick={this.onSave}>Opdater</button>
                        <button className="btn-secondary float-right" onClick={() => {this.props.onClose()}}>Annuller</button>
                    </div>
                </div>
            </Modal>
        </div>
    }

    onSave = () => {
        if (this.allInputValid()) {
            const additions = this.props.sections.filter(section => this.state['Section' + section.Sektionsnr] !== '').map(section => ({
                Sektionsnr: section.Sektionsnr,
                Beloeb: Number(this.state['Section' + section.Sektionsnr].replace(',', '.'))
            }));
            this.props.dispatch(RaceActions.updatePriceAdditions(this.props.priceType, this.props.raceId, additions, () => {
                NotificationManager.success("Præmietillæggene er opdateret. Husk at genberegne præmierne.", "Opdatering", 4000);
                this.props.onClose();
            }));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(PriceAdditionsDialog);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/race/dialogs/PriceAdditionsDialog.js